/** aegis 上报系统 https://aegis.woa.com/sdk/web.html#setconfig  */
export type AegisProps = {
  /** 该方法用来修改实例配置 */
  setConfig?: ({
    uin,
  }: {
    uin: string;
    pvUrl?: string;
    whiteListUrl?: string;
  }) => void;
  /** 该方法用于销毁 sdk 实例，销毁后，不再进行数据上报 */
  destroy?: () => void;
  /** 上报一条白名单日志，这两种情况这条日志才会报到后台：1、打开页面的用户在名单中；2、对应的页面发生了错误 */
  info?: (msg: string) => void;
  /** 上报了一条日志，该上报与info唯一的不同就在于，所有用户都会上报 */
  infoAll?: (
    msg:
      | string
      | {
          msg: string;
          ext1?: string;
          ext2?: string;
          ext3?: string;
        },
  ) => void;
  /** 主动上报一个错误 */
  error?: (params: {
    msg: string;
    ext1: any;
    ext2: any;
    ext3: any;
    trace: string;
  }) => void;
  /** report 默认是 aegis.report 的日志类型，但是现在你可以传入任何日志类型了 */
  report?: ({
    msg,
    level,
    ext1,
    ext2,
    ext3,
    trace,
  }: {
    msg: any;
    level: any;
    ext1?: any;
    ext2?: any;
    ext3?: any;
    trace?: any;
  }) => void;
  /** 自定义上报 */
  reportEvent?: ({
    name,
    ext1,
    ext2,
    ext3,
  }: {
    name: string;
    ext1?: any;
    ext2?: any;
    ext3?: any;
  }) => void;
};

/** 事件类型 */
export enum EventTypeEnum {
  /** 页面切换进入 */
  PV = 1,
  /** 用户第一次进入 */
  UV = 2,
  /** 点击 */
  CLICK = 3,
  /** 信息 */
  INFO = 4,
  /** 错误 */
  ERROR = 5,
  /** 警告 */
  WARN = 6,
  /** 输入 */
  INPUT = 7,
  /** 鼠标悬浮 */
  HOVER = 8,
  /** 框架初始化 */
  APP_PE = 9,
  /** 切换页面路由 */
  PAGE_PE = 10,
  /** 自定义性能上报 */
  CUSTOM_PE = 11,
  /** 请求超过 5s  */
  REQUEST_EVENT = 12,
}

/** 当前系统自定义上报 Api 传值 */
export interface UploadReportParams {
  /** 页面路径 */
  path?: string;
  /** 用户唯一id  */
  uin?: string;
  accountId?: string;
  /** 页面名称 */
  moduleName?: string;
  /** 事件名称 */
  eventName?: string;
  /** 事件类型 */
  eventType: EventTypeEnum | number;
  /** 错误信息 */
  errMsg?: string;
  /** 性能指标 */
  performance?: Record<any, any>;
  /** 扩展字段 */
  exts?: Record<any, any>;
}

export type PropsType = {
  /** 上报 用户唯一信息 */
  uin: string;
  /** 上报系统 id */
  aegisId: string;
  /** aegis 上报配置 */
  aegisConfig?: any;
  /** aegis 上报调用api  */
  aegisApi?: AegisProps;
};
export enum LogType {
  API_RESPONSE = '1', // 白名单中的用户，页面上的所有 API 返回都将会被上报
  INFO = '2', // aegis.info、aegis.infoAll 上报的日志
  ERROR = '4', // js 错误
  PROMISE_ERROR = '8', // promise 错误
  AJAX_ERROR = '16', // ajax 错误
  SCRIPT_ERROR = '32', // script 加载失败
  IMAGE_ERROR = '64', // 图片加载失败
  CSS_ERROR = '128', // css 加载失败
  CONSOLE_ERROR = '256', // console.error 监控（目前暂未支持）
  MEDIA_ERROR = '512', // 音视频加载失败
  RET_ERROR = '1024', // retcode 返回码异常
  REPORT = '2048', // aegis.report 上报日志默认level
  PV = '4096', // 页面 PV
  EVENT = '8192', // 自定义事件
  PAGE_NOT_FOUND_ERROR = '16384', // 小程序 页面不存在
  WEBSOCKET_ERROR = '32768', // websocket错误
  BRIDGE_ERROR = '65536', // js bridge 错误
}
